import React, { Dispatch, SetStateAction, useState } from "react";
import { changeNumComma } from "../../../../../AdminApi/commFunc";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import { Input } from "../../../../Input/Input";
import CalendarModal from "../../../../Modal/CalendarModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import {
  CommentTargetContainer,
  ModalLabel,
} from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { ValueContainer } from "../CouponPointRegisterModal";

interface PointValueInputProps {
  inputPointValue: string;
  setInputPointValue: Dispatch<SetStateAction<string>>;
  pointExpDate: string;
  setPointExpDate: Dispatch<SetStateAction<string>>;
}

export default function PointValueInput({
  inputPointValue,
  setInputPointValue,
  pointExpDate,
  setPointExpDate,
}: PointValueInputProps) {
  const [dateClick, setDateClick] = useState(false);

  return (
    <>
      <ModalRow>
        <ModalLabel>지급 포인트</ModalLabel>

        <ValueContainer>
          <Input
            placeholder="직접 입력"
            value={inputPointValue}
            onChange={(e) =>
              setInputPointValue(changeNumComma(e).toLocaleString("ko"))
            }
            type="text"
            inputMode="numeric"
            style={{ width: "calc(100% - 10px - 85px)" }}
          />
        </ValueContainer>
      </ModalRow>

      <ModalRow>
        <ModalLabel>포인트 만료일</ModalLabel>

        <CommentTargetContainer>
          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setDateClick(true)}
              value={pointExpDate}
              initValue={"시작일"}
              disabled={false}
            />

            {dateClick && (
              <CalendarModal
                closeEvent={() => setDateClick(false)}
                changeEvent={(date: string) => setPointExpDate(date)}
              />
            )}
          </LineBoxContainer>
        </CommentTargetContainer>
      </ModalRow>
    </>
  );
}
